var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tab-item',{staticClass:"pa-3",attrs:{"value":_vm.$route.fullPath}},[_c('v-toolbar',{attrs:{"flat":"","height":"90"}},[_c('v-spacer'),_c('v-col',{attrs:{"cols":"12","sm":"4"}},[_c('b-search-field')],1)],1),_c('v-data-table',{staticClass:"b-outlined",attrs:{"headers":_vm.headers,"items":_vm.multipleCoupons,"footer-props":{
      itemsPerPageOptions: [12],
      showCurrentPage: true,
      pageText: `${_vm.page * 12 - 11}-${
        _vm.page * 12 <= _vm.serverItemsLength ? _vm.page * 12 : _vm.serverItemsLength
      } ${_vm.translations.paginationText[_vm.lang]} ${_vm.serverItemsLength}`,
    },"page":_vm.page,"server-items-length":_vm.serverItemsLength,"loading":_vm.loading},on:{"update:page":function($event){_vm.page=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }